/**
 * UploadTarget: tells FileUploadR *where* an in-form file upload should go.
 *
 * SchemaRenderer is used in several places (the live intake form, the staff
 * forms-review catalogue, the schema preview/demo pages). Only the live
 * intake form has a real matter, a real contact, and an unambiguous uploader
 * role to attach an upload to, so it's the only place that renders
 * <UploadTargetProvider>. Everywhere else the context stays at its default of
 * null, and FileUploadR renders a disabled picker instead of a false working
 * affordance.
 */

import { createContext, useContext, type ReactNode } from 'react';

export interface UploadTargetValue {
  matterId: string;
  contactId: string;
  uploaderRole: 'applicant' | 'sponsor';
}

const UploadTargetContext = createContext<UploadTargetValue | null>(null);

export function UploadTargetProvider({
  value,
  children,
}: {
  value: UploadTargetValue;
  children: ReactNode;
}) {
  return (
    <UploadTargetContext.Provider value={value}>
      {children}
    </UploadTargetContext.Provider>
  );
}

/** Returns null when rendered outside a live intake form (e.g. previews). */
export function useUploadTarget(): UploadTargetValue | null {
  return useContext(UploadTargetContext);
}
